import Layout from 'components/layout';
import LoginSection from 'components/account/loginSection';
import { reformatLocaleToContentfulLocale } from 'lib/utils/helpers';
import { getGlobal } from 'lib/contentful';
import useCustomer from 'hooks/customer/useCustomer';
import Icon from 'components/shared/icon';
import { useSalons } from 'hooks';

export const Login = ({ previewData, locale, globalModules }) => {
  const { customer } = useCustomer({ redirectTo: '/account/dashboard', redirectIfFound: true });

  useSalons(locale);

  return (
    <Layout locale={locale} previewData={previewData} globalModules={globalModules} cookieBar>
      {customer?.isLoggedIn ? (
        <div
          style={{
            height: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Icon type="loading" />
        </div>
      ) : (
        <LoginSection
          locale={locale}
          loginpage={globalModules?.loginpage}
          secondpartloginpage={globalModules?.secondpartloginpage}
        />
      )}
    </Layout>
  );
};

export async function getStaticProps({ previewData = null, locale }) {
  const globalModules = await getGlobal(
    [
      'loginpage',
      'secondpartloginpage',
      'announcement-bar',
      'cookies',
      'firstcountryselectorlocales',
    ],
    reformatLocaleToContentfulLocale(locale)
  );

  const { localesWithWebshop } = globalModules?.settings;

  if (!localesWithWebshop.onOrOff)
    return {
      notFound: true,
    };

  return {
    props: { previewData, locale, globalModules },
  };
}

export default Login;
